<template lang="html">
  <v-layout
    wrap
    :class="{'no-print': !print}"
  >
    <v-flex
      v-if="section.title"
      xs12
      mt-4
    >
      <div class="headline font-weight-light">
        <v-layout
          ma-0
          align-center
        >
          <span class="my-1">{{ section.title }}</span>
          <v-spacer />
          <v-flex
            v-if="section.canHide"
            shrink
            pa-0
            class="no-print"
          >
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-layout
                  ma-0
                  align-center
                  justify-end
                  v-on="on"
                >
                  <v-label>Print</v-label>
                  <v-switch
                    v-model="print"
                    inset
                    dense
                    hide-details
                    class="ma-0 my-1 mr-n4 ml-4"
                    tabstop="-1"
                  />
                </v-layout>
              </template>
              <span>Hide this section when printing. <br><i>Current setting: {{ print ? 'SHOW' : 'HIDE' }}</i></span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
      <v-divider class="primary mb-2" />
    </v-flex>
    <!-- <v-flex xs12 class="body-1" v-if="section.textPre && !section.component" v-html="_templateLiteralString(section.textPre)"></v-flex> -->
    <v-flex
      v-if="section.textPre && !section.component"
      xs12
      class="body-1 "
      v-html="section.textPre"
    />
    <v-flex
      v-if="section.component"
      xs12
      pa-0
      class="body-1"
    >
      <!-- <component v-bind:is="section.component" :report="report" :section="section" :print="print"></component> -->
      <component
        :is="section.component"
        :data="data"
        :section="section"
        :print="print"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    // report: Object,
    data: Object,
    section: Object,
  },
  data () {
    return {
      print: true
    }
  },
  computed: {

  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
